import { EducationLevel } from './education-level.interface';
import { EducationLevelService } from './education-level.service';

const service = new EducationLevelService();

export interface EducationLevelState {
   educationLevels: Array<EducationLevel>;
}

const state: EducationLevelState = {
   educationLevels: [],
};
const getters = {
   educationLevels(state: EducationLevelState) {
      return state.educationLevels;
   },
};

const mutations = {
   SET_EDUCATION_LEVELS(state: EducationLevelState, educationLevels: Array<EducationLevel>) {
      state.educationLevels = educationLevels;
   },
};
const actions = {
   async getEducationLevels({ commit }: any) {
      return await service.getEducationLevels().then((response) => {
         commit('SET_EDUCATION_LEVELS', response);
         return response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
